import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioOrdenAdmisionService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getOrdenAdmision(codigoBaseDatos: string, consecutivo: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'admision/procedimientos-seleccion', [codigoBaseDatos, { consecutivo : consecutivo }]);
      return response;
    } catch (e) {
      console.error(`ServicioOrdenAdmisionService.getOrdenAdmision()`, e);
    }
  }

  async getOrdenSuministroAdmision(codigoBaseDatos: string, consecutivo: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'admision/suministros-seleccion', [codigoBaseDatos, { consecutivo }]);
      return response;
    } catch (e) {
      console.error(`ServicioOrdenAdmisionService.getOrdenSuministroAdmision()`, e);
    }
  }

}

export interface FiltrosOrdenAdmisionEntity {
  codigoBaseDatos ?: string;
  uncoSede ?: number;
  uncoLogin ?: number;
  consecutivo ?: string;
  valores ?: boolean;
}

export interface PacienteOrdenAdmisionEntity {
  afiliado: string;
  consecutivoAdmision: string;
  empresa: string;
  fechaAdmision: number;
  fechaSalidaAdmision?: any;
  sede: string;
  puntoAtencion: string;
  tipoAfiliado: string;
  tipoDocumento: string;
  rangoSalarial: string;
  numeroIdentificacion: string;
  fechaNacimiento: number;
  edad: string;
}

export interface DataOrdenAdmisionEntity {
  afiliado: string;
  consecutivoAdmision: string;
  empresa: string;
  fechaAdmision: number;
  fechaSalidaAdmision?: any;
  codigoSede: number;
  sede: string;
  codigoPuntoAtencion: number;
  puntoAtencion: string;
  tipoAfiliado: string;
  tipoDocumento: string;
  genero: string;
  rangoSalarial: string;
  numeroIdentificacion: string;
  fechaNacimiento: number;
  edad: string;
  codigoProcedimiento: number;
  procedimiento: string;
  fechaOrden: number;
  cantidad: number;
  valorUnitario: number;
  usuarioModificacion: string;
  profesionalRealiza: string;
  profesionalOrdena: string;
}

export interface DataOrdenSuministroAdmisionEntity {
  afiliado: string;
  consecutivoAdmision: string;
  empresa: string;
  fechaAdmision: number;
  fechaSalidaAdmision?: number;
  codigoSede: number;
  sede: string;
  codigoPuntoAtencion: number;
  puntoAtencion: string;
  tipoAfiliado: string;
  tipoDocumento: string;
  genero: string;
  rangoSalarial: string;
  numeroIdentificacion: string;
  fechaNacimiento: number;
  edad: string;
  codigoSuministro: number;
  suministro: string;
  fechaOrden: number;
  cantidad: number;
  valorUnitario: number;
  usuarioModificacion: string;
  profesionalOrdena: string;
  numeroLote: string;
  fechaVencimiento: number;
}
